import React from 'react';
import { SwitchProps as SwitchPropsDefault } from 'antd/lib/switch';
import { useTheme } from 'styled-components';
import { Container, StyledSwitch, SwitchLabel } from './Switch.styled';

export type SwitchProps = SwitchPropsDefault & {
  label?: string | React.ReactNode;
  small?: boolean;
  color?: string;
};

export function Switch({ label, small, color, ...props }: SwitchProps) {
  const { colors } = useTheme();
  const resolvedColor = color ?? colors.element.primary;
  const id = `switch-${Math.random()}`;
  return (
    <Container>
      <StyledSwitch size={small ? 'small' : 'default'} {...props} id={id} />
      {label && (
        <SwitchLabel htmlFor={id} $color={resolvedColor}>
          {label}
        </SwitchLabel>
      )}
    </Container>
  );
}
